import React, { useState, useMemo, useEffect } from "react"
import {
	Box,
	FormControl,
	Select,
	MenuItem,
	InputLabel,
	ListSubheader,
	TextField,
	Tooltip,
	Checkbox,
	ListItemText,
	Typography,
	Paper,
	useTheme,
} from "@material-ui/core"
import { KeyboardArrowDown } from "@material-ui/icons"
import { Skeleton } from "@material-ui/lab"
import { makeStyles } from "@material-ui/core/styles"
import "./DropdownWithSearch.css"

const useStyles = makeStyles((theme) => ({
	header: {
		position: "sticky",
		top: 0,
		paddingLeft: 10,
		paddingRight: 10,
		paddingBottom: 10,
		zIndex: 2,
		background: theme.palette.common.white,
	},
	card: {
		width: "100%",
	},
	search: {
		"& .MuiFilledInput-root": {
			border: `1px solid ${theme.palette.grey[50]}`,
			borderRadius: "3px",
			background: theme.palette.grey[50],
		},
		"& .MuiInputBase-input": {
			boxShadow: "none",
		},
		"& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
			border: "transparent",
		},
	},
	select: {
		"& .MuiSvgIcon-root": {
			color: theme.palette.text.primary,
		},
		"& .MuiSelect-root": {
			...theme.typography.body1,
		},
	},
}))

const containsText = (text, searchText) => text.toLowerCase().indexOf(searchText.toLowerCase()) > -1

const MenuProps = {
	PaperProps: {
		style: {
			maxWidth: 198,
			minWidth: 198,
			//minWidth: 100,
			maxHeight: 222,
			minHeight: 222,
			//textTransform: "capitalize",
			//overflow: "auto",
		},
	},
	anchorOrigin: {
		vertical: "bottom",
		horizontal: "left",
	},
	getContentAnchorEl: null,
}

const DropdownWithSearch = ({
	label = "Email",
	handleListChange,
	isLoading = false,
	list = [],
	resetFilter = false,
	selectedOptions = [],
	setSelectedOptions = () => {},
	disableFilters,
}) => {
	const classes = useStyles()
	const theme = useTheme()
	const [searchText, setSearchText] = useState("")
	//const filteredData = useMemo(() => list.filter((option) => containsText(option, searchText)), [searchText])
	const filteredData = list?.filter((option) => containsText(option, searchText))
	const handleChange = (event) => {
		setSelectedOptions(event.target.value)
	}

	useEffect(() => {
		handleListChange(selectedOptions)
	}, [selectedOptions])

	const handleClear = () => {
		setSelectedOptions([])
	}

	return (
		<Box
			style={{
				maxWidth: 140,
				minWidth: 140,
				minHeight: 48,
				maxHeight: 48,
				backgroundColor: theme.palette.common.white,
				border: `solid 1px ${theme.palette.grey.D400}`,
				borderRadius: "5px",
			}}
			m={1}
		>
			<FormControl fullWidth size="small" variant="outlined">
				<InputLabel id="search-select-label-input">{label}</InputLabel>
				<Tooltip placement="top" arrow title={selectedOptions.join(", ")}>
					<Select
						variant="outlined"
						MenuProps={MenuProps}
						labelId="search-select-label"
						id="search-select"
						value={selectedOptions}
						label="Options"
						onChange={handleChange}
						onClose={() => setSearchText("")}
						multiple
						IconComponent={KeyboardArrowDown}
						renderValue={() => selectedOptions}
						className={classes.select}
						// MenuProps={{
						// 	anchorOrigin: {
						// 		vertical: "bottom",
						// 		horizontal: "left",
						// 	},
						// 	getContentAnchorEl: null,
						// }}
					>
						{isLoading &&
							Array(5)
								.fill()
								.map((data, i) => (
									<MenuItem key={i} value={""}>
										<Skeleton variant="rounded" width={130} height={30} />
									</MenuItem>
								))}
						{!isLoading && list.length && (
							<div className={classes.header}>
								<Paper className={classes.card} elevation={0}>
									<TextField
										className={classes.search}
										size="medium"
										autoFocus
										placeholder="Search"
										fullWidth
										onChange={(e) => setSearchText(e.target.value)}
										SelectProps={{
											IconComponent: KeyboardArrowDown,
										}}
										onKeyDown={(e) => {
											if (e.key !== "Escape") {
												e.stopPropagation()
											}
										}}
										onClick={(e) => e.stopPropagation()}
										variant="filled"
										InputProps={{
											disableUnderline: true,
											// "&&&:before": {
											// 	borderBottom: "none",
											// },
											// "&&:after": {
											// 	borderBottom: "none",
											// },
										}}
										disabled={disableFilters}
									/>
								</Paper>
							</div>
						)}
						{!isLoading && list.length <= 0 && <ListItemText className="no-data-found-item" primary={"No Data Found"} />}

						{list.length > 0 &&
							filteredData.map((option, i) => (
								<MenuItem key={`${option}-${i}`} value={option}>
									<Checkbox checked={selectedOptions.indexOf(option) > -1} />
									<Tooltip placement="top" arrow title={option}>
										<Typography nowrap className="typography-ellipsis">
											{option}
										</Typography>
									</Tooltip>
								</MenuItem>
							))}
					</Select>
				</Tooltip>
			</FormControl>
		</Box>
	)
}

export default DropdownWithSearch
